import DocumentTemplateEditBlock from 'components/_dashboardPagesFeatures/documentTemplate/DocumentTemplateEditBlock';
import LoaderComponent from 'components/ui/loadingIndicators/LoaderComponent';
import useDI from 'hooks/useDI';
import useInitializePage from 'hooks/useInitializePage';
import React from 'react';
import { useParams } from 'react-router';
import { RoutingServiceDashboard } from 'services/routing/RoutingService';
import { useSelector } from 'storage';

function EnterpriseDocumentTemplateAddPage() {
  const { services } = useDI();
  const { translate } = services.language;
  const pathParams = useParams();
  const { permissions } = useSelector((state) => state.auth);
  const { enterprise, enterpriseIsLoading } = useSelector((state) => state.enterprise);

  const isPageInitialized = useInitializePage(() => {
    const menu: MenuIconItemData[] = [];
    const breadcrumbs = RoutingServiceDashboard.modelsDirectory.documentTemplate.getAddBc(pathParams, permissions, translate, {
      enterpriseName: enterprise?.name || '',
    });
    const title = translate('pages.documentTemplate.addPageTitle');
    return { breadcrumbs, menu, title };
  }, [enterpriseIsLoading]);

  if (!isPageInitialized) return <LoaderComponent />;

  return <DocumentTemplateEditBlock documentTemplate={null} />;
}

export default React.memo(EnterpriseDocumentTemplateAddPage, () => true);
